<template>
  <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex sm12 xs12>
        <v-card dark color="primary">
          <v-card-text class="px-0">
            <h2>This is Maps Page</h2>
            <div id="sinemaps"></div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>

  export default {
    mounted () {
      var map = new Datamap(
        {
          element: document.getElementById('sinemaps'),
          fills: {
            defaultFill: 'rgba(76,175,80,1)' // Any hex, color name or rgb/rgba value
          },
          geographyConfig: {
            highlightOnHover: true,
            popupOnHover: true
          }
        }
      );
    }
  }
</script>
